import { useAuth } from '@gen2/hooks';
import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

type PlanRequiredRouteProps = { children: ReactNode };

const PlanRequiredRoute: FC<PlanRequiredRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const currentOrgId = sessionStorage.getItem('FI-ORGANISATION-ID');
  const currentOrg = user?.organisations?.find(
    (org) => org.id === currentOrgId,
  );

  // If no plan exists, redirect to unauthorized
  if (!currentOrg?.plan) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children as JSX.Element;
};

export default PlanRequiredRoute;
